import { getLabel } from '@modusign/openapi-client-category';
import { GetLabelResponseDto } from '@modusign/openapi-client-category/generated/model';
import { getMember } from '@modusign/openapi-client-user';
import { GetMemberResponseDto } from '@modusign/openapi-client-user/generated/model';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { InvestibleSelectableLabelId } from '@app/features/label/types';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

type LabelResponse = GetLabelResponseDto & {
  member: GetMemberResponseDto | null;
};

export default function useResourceLabel(id: InvestibleSelectableLabelId) {
  const workspaceId = useWorkspaceId();
  return useQuery<LabelResponse, AxiosError>({
    queryKey: ['label', workspaceId, id],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const label = await getLabel(workspaceId, id!);
      const member = label.memberId ? await getMember(workspaceId, label.memberId) : null;
      return { ...label, member };
    },
    enabled: !!(workspaceId && id && id !== 'unlabeled'),
  });
}
